<template>
  <component v-if="!checkIsIframe"
             :is="type"
             :attachment="attachment"
             :selectDot="selectDot"
             :getPostDirection="getPostDirection"
             :position="position"
             :lengthOfAttach="lengthOfAttach"
             @togglePreview="$emit('togglePreview')"
             :context="context" />
  <iframe v-else-if="checkIsIframe"
          :src="attachment.url"
          class="adjust-size" scrolling="yes" />
</template>

<script>
import AttachmentImage from './Image'
import AttachmentLink from './Link'
import AttachmentFile from './File'
import AttachmentWhiteboard from './Whiteboard'
import AttachmentVideo from './Video'
import AttachmentEmbeddedVideo from './EmbeddedVideo'
import AttachmentProject from './Project'
import AttachmentPoll from './Poll.vue'
import AttachmentIframe from './Iframe'
import AttachmentMeeting from './Meeting'

export default {
  components: {
    AttachmentImage,
    AttachmentLink,
    AttachmentIframe,
    AttachmentFile,
    AttachmentWhiteboard,
    AttachmentVideo,
    AttachmentEmbeddedVideo,
    AttachmentProject,
    AttachmentPoll,
    AttachmentMeeting
  },
  props: ['attachment', 'context', 'selectDot', 'carousel', 'position', 'lengthOfAttach', 'getPostDirection'],
  computed: {
    type: function () {
      return this.attachment ? `attachment-${this.attachment.type}` : null
    },
    checkIsIframe: function () {
      return this.attachment.type === 'iframe'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .adjust-size {
    overflow: scroll;
    @include mobile-and-ipad {
      height: 320px;
      width: 100%;
    }
    @include desktop {
      height: 500px;
      width: 100%;
    }
    @media (max-width: 1019px) {
      height: 600px;
      width: 100%;
    }
    @media (max-width: 375px) {
      height: 320px;
      width: 100%;
    }
    @media (min-height: 667px) {
      height: 600px;
      width: 100%;
    }
  }
</style>
